export default __webpack_public_path__ + "static/media/switch-icon.ae8003db.svg";